import React from 'react'
import { Box, Center, FormControl, Input, ScaleFade, Spinner, Text, Textarea } from '@chakra-ui/react';
import { Stack } from '@chakra-ui/react';
import { FormLabel } from '@chakra-ui/react';
import { FormErrorMessage } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import FileUploader from '../../../Shared/FileUploader/FileUploader';
import ImageListViewer from '../../../Shared/FileListViewer/FileListViewer';
import { PlusSquareIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { Redirect } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';

let inputStyle = {
    backgroundColor: "white",
    borderRadius: "0.1em",
    border: "1px solid #333"
}

interface IJobForm {
    isLoading: boolean;
    successMessage: string;
    onSubmit: any;
    register: any
}

export const JobForm = (props: any) => {
    const {
        isLoading,
        register,
        errors,
        control,
        getValues,
        setValue,
        currentJob,
        setFileArray,
        fileArray,
        setFilesToBeDeleted,
        isSubmitting,
        isEdit,
        onSubmit,
        isSafeToRedirect,
        params,
        handleSubmit
    } = props;
    return (
        <div>
            <ScaleFade key="Add-Jobs" initialScale={0.1} in>
                <Box
                    maxWidth={"600px"}
                    margin="auto"
                    bg="white"
                    padding={4}
                    rounded="md"
                >
                    {/* {(isSafeToRedirect && (!params.JobID)) && <Redirect to={`/${params.tenantID}/admin/jobs/all`} />}
                    {(isSafeToRedirect && data.pathFrom === "jobcard") && <Redirect to={`/${params.tenantID}/admin/calendar`} />}
                    {(isSafeToRedirect && data.pathFrom === "jobboard") && <Redirect to={`/${params.tenantID}/admin/jobs/all`} />} */}
                    {isLoading ?
                        <Center>
                            <Stack>
                                {props.successMessage}
                                <Center>
                                    <Spinner m="auto" />
                                </Center>
                            </Stack>
                        </Center>

                        : <>
                            <form onSubmit={handleSubmit((values) => onSubmit(values))}>

                                <FormControl >
                                    <Stack spacing="10px" >
                                        <Box >
                                            <FormLabel htmlFor="CustomerName">Customer's Name</FormLabel>
                                            <Input
                                                id="CustomerName"
                                                {...inputStyle}
                                                placeholder="Samantha"
                                                {...register("CustomerName", {
                                                    required: "This is required",
                                                    minLength: { value: 4, message: "Minimum length should be 4" }
                                                })}
                                            />
                                            <FormErrorMessage>
                                                {errors.CustomerName && errors.CustomerName.message}
                                            </FormErrorMessage>
                                        </Box>


                                        <Box >
                                            <FormLabel htmlFor="Title">Job Title</FormLabel>
                                            <Input
                                                id="Title"
                                                {...inputStyle}
                                                placeholder="eg. Samantha's backyard job"
                                                {...register("Title", {
                                                    required: "This is required",
                                                    minLength: { value: 4, message: "Minimum length should be 4" }
                                                })}
                                            />
                                            <FormErrorMessage>
                                                {errors.Title && errors.Title.message}
                                            </FormErrorMessage>
                                        </Box>

                                        <Box>
                                            <FormLabel htmlFor="Address">Address</FormLabel>
                                            <Textarea placeholder="eg.  4001 36 Jane Bell Lane"
                                                {...inputStyle}
                                                id="Address"
                                                {...register("Address", {
                                                    required: "This is required",
                                                    minLength: { value: 4, message: "Minimum length should be 4" }
                                                })}
                                            />
                                            <FormErrorMessage>
                                                {errors.Address && errors.Address.message}
                                            </FormErrorMessage>
                                        </Box>

                                        <Box display={{ base: "unset", sm: "flex" }}>
                                            <Box mr="2">
                                                <FormLabel htmlFor="StartDateTime">Job Start Time</FormLabel>

                                                <Controller
                                                    control={control}
                                                    name='StartDateTime'
                                                    // {...register("StartDateTime", {
                                                    //     required: "This is required",
                                                    // })}
                                                    // {...inputStyle}
                                                    render={({ field }) => {
                                                        return <DateTimePicker
                                                            ref={field.ref}
                                                            onChange={(date: any) => {
                                                                if (!getValues().EndDateTime) {
                                                                    setValue("EndDateTime", date)
                                                                }
                                                                field.onChange(date)

                                                            }}
                                                            value={field.value}
                                                            disableClock

                                                        />
                                                    }}
                                                />
                                            </Box>
                                            <Box>

                                                <FormLabel htmlFor="EndDateTime">Job End Time</FormLabel>
                                                <Controller
                                                    control={control}
                                                    name='EndDateTime'
                                                    // {...register("EndDateTime", {
                                                    // required: "This is required",
                                                    // })}
                                                    // {...inputStyle}
                                                    render={({ field }) => (
                                                        <DateTimePicker
                                                            ref={field.ref}

                                                            id="EndDateTime"
                                                            onChange={(date: any) => field.onChange(date)}
                                                            value={field.value}
                                                            disableClock
                                                        />
                                                    )}
                                                />
                                            </Box>

                                        </Box>

                                        {/* <Box mt={2}>
                                        <FormLabel htmlFor="AssignTo">Assign Job to</FormLabel>

                                        <FormErrorMessage>
                                            {errors.StartDateTime && errors.StartDateTime.message}
                                        </FormErrorMessage>

                                        <Select
                                            isMulti
                                            name="AssignTo"
                                            options={[
                                                { value: 'Unassigned', label: 'Unassigned' },
                                                { value: 'Sarah', label: 'Sarah' },
                                                { value: 'John', label: 'John' },
                                                { value: 'Jacob', label: 'Jacob' }
                                            ]}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                        />
                                    </Box> */}
                                        <Box>
                                            <FormLabel htmlFor="Note">Job Notes</FormLabel>
                                            <Textarea placeholder="eg.  Property has a dog that should already been tied up during the job period."
                                                {...inputStyle}
                                                id="Address"
                                                {...register("Note", {
                                                })}
                                            />
                                            <FormErrorMessage>
                                                {errors.Note && errors.Note.message}
                                            </FormErrorMessage>
                                        </Box>
                                        <Box>
                                            <ImageListViewer
                                                setFilesToBeDeleted={setFilesToBeDeleted}
                                                isEdit
                                                setFileArray={setFileArray} //to delete pictures
                                                fileArray={fileArray} //get existing files
                                            />

                                            <FileUploader
                                                registerName="JobFiles"
                                                Files={currentJob?.JobFiles}
                                                setFileArray={setFileArray}
                                                fileArray={fileArray}
                                                register={register} />

                                        </Box>

                                    </Stack>

                                </FormControl>

                                <Box>
                                    {!isEdit ?
                                        <Button
                                            width="100%"
                                            mt={8}
                                            backgroundColor="green.600"
                                            color="white"
                                            isLoading={isSubmitting}
                                            type="submit"
                                            borderRadius="1.5em"

                                        >
                                            <PlusSquareIcon w={4} h={4} mt={0.5} /> &nbsp; Create Job
                                        </Button>
                                        :
                                        <Button
                                            width="100%"
                                            mt={8}
                                            backgroundColor="green.600"
                                            color="white"
                                            isLoading={isSubmitting}
                                            type="submit"
                                            // borderRadius="0.1em"
                                            borderRadius="1.5em"
                                        >
                                            Edit Job
                                        </Button>}
                                    {!params.JobID && <Text mt={3} align="center">Once a job is created, you can start adding tasks to it.</Text>}
                                </Box>
                            </form>
                        </>}
                </Box>
            </ScaleFade >

        </div>
    )
}



